module.exports = __webpack_public_path__ + "img/doc-file.edac6ced.svg";